import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import Layout from "../layouts/blog"
import Img from "gatsby-image"
import styled from 'styled-components'

import Bio from '../components/Bio'
import SignUp from '../components/book/SignUp'
import { rhythm } from '../utils/typography'

const Preview = styled.div`
  display: flex;

  margin-top: 2em;  
`

const PreviewText = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 30%;

  padding-right: 1em;

  h3 {
    margin-top: 0;
  }
`

const PreviewImage = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
`

class BlogIndex extends React.Component {
  render() {
    const posts = get(this, 'props.data.allContentfulPost.edges')

    return (
      <React.Fragment>
        <Layout location={this.props.location} addedWidth={6}>
        <div>
          <Helmet title={'Find Better Questions Blog'} />
          <Bio />
          {posts && posts.map(({ node }) => {
            console.log({node})
            const title = get(node, 'title') || node.slug
            return (
              <Preview key={node.slug}>
                <PreviewText>
                  <h3
                    style={{
                      marginBottom: rhythm(1 / 4),
                    }}
                  >
                    <Link style={{ boxShadow: 'none' }} to={`blog/${node.slug}`}>
                      {title}
                    </Link>
                  </h3>
                  <small>
                    {new Date(node.createdAt).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                    —{node.text.childMarkdownRemark.timeToRead} min read
                  </small>
                  <p dangerouslySetInnerHTML={{ __html: node.text.childMarkdownRemark.excerpt}} />
                </PreviewText>
                <PreviewImage>
                  <Img fluid={node.titleImage.fluid} />
                </PreviewImage>
              </Preview>
            )
          })}
        </div>
      </Layout>
      <SignUp additionalText="Want to master Quora Marketing? Read the Ulimate Guide 📙 "/>
      </React.Fragment>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query IndexQuery {
    allContentfulPost(limit: 1000) {
      edges {
        node {
          slug,
          createdAt,
          title,
          titleImage {
            fluid(maxWidth: 1500) {
              aspectRatio
              sizes
              src
              srcSet
              srcWebp
          		srcSetWebp
            }
          },
          text {
            childMarkdownRemark {
                excerpt,
                timeToRead
              }
          }
        }
      }
    }
  }
`
